import { HttpClient, type IHttpClient } from "../../../services/HttpClient";
import type { MainQuestions } from "./MainQuestions";

export class SignalService {
	private constructor(private httpClient: IHttpClient) {}

	private static instance: SignalService;

	static create() {
		if (!SignalService.instance) {
			SignalService.instance = new SignalService(HttpClient.create());
		}
		return SignalService.instance;
	}

	async getData(): Promise<MainQuestions> {
		const { data } =
			await this.httpClient.get<MainQuestions>("/main-questions");
		return data;
	}
}
